<template>
  <div class="activity" @selectstart.prevent="() => {}">
    <img :src="banner.imgUrl" class="cov-img page-banner" alt="">
    <div class="act-content center">
      <pane-title title="年度峰会" sub-title="Event" />

      <div class="tab-list">
        <div
            v-for="(item, i) in summitList"
            :class="{'tab-item': true, 'active-item': i === currentSummit, [`tab-item-`+i]: true}"
            :key="i"
            @click="toSlide(i)"
        >{{ lang === 'zh' ? '' : 'The ' }}{{item.publishTime}}{{lang === 'zh' ? '年峰会' : 'Summit'}}</div>
      </div>

      <div class="swiper-box">
        <swiper
            :options="commonOptions"
            ref="swiper"
        >
          <swiper-slide v-for="(item, i) in summitList" :key="`1-${i}`">
            <div class="box" @click="jumpPage(item.jumpUrl)">
              <div class="img">
                <img :src="item.pcImgUrl" alt="">
              </div>
              <div class="bottom-msg">
                <p class="tit wrap-txt">{{item.title}}</p>
                <p class="txt">
                  {{item.description}}
                </p>
                <p class="more-link">
                  <span class="link-tag-small">&lsaquo;&nbsp;{{ lang === 'zh' ? '详情' : 'More' }}&nbsp;&rsaquo;</span>
                </p>
              </div>
            </div>
          </swiper-slide>
        </swiper>

        <div class="btn next btn-next-1" @click="toNext()">
          <img src="../../assets/activity/swiper-right.jpg" alt="">
        </div>
        <div class="btn prev btn-prev-1" @click="toPrev()">
          <img src="../../assets/activity/swiper-left.jpg" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { activityPageData } from "../../utils/Local-Data";
const { tabList, discussionSwiper, scienceSwiper, meetingSwiper } = activityPageData;

export default {
  name: "Activity",
  data() {
    return {
      banner: {},
      sList: [],
      aList: [],
      currentSummit: 0,
      commonOptions: {
        // autoplay: {
        //   disableOnInteraction: false
        // },
        autoDestroy: true,
        deleteInstanceOnDestroy: true,
        observeParents: true,
        observer: true,
        observeSlideChildren:true
      },
      summitList: [],
      tabList,
      discussionSwiper,
      scienceSwiper,
      meetingSwiper
    }
  },
  computed: {
    swiper() {
      return this.$refs.swiper.$swiper;
    },
    lang() {
      return this.$store.state.plang;
    }
  },
  methods: {
    jumpPage(url) {
      if(url) {
        window.open(url);
      }
    },
    onTabChange(id) {
      this.currentTab = id;
    },
    toPrev() {
      const _i = this.swiper.activeIndex;

      this.currentSummit = _i <= 0 ? 0 : _i - 1;
      this.swiper.slidePrev();
    },
    toNext() {
      const _i = this.swiper.activeIndex;
      this.currentSummit = _i <= this.summitList.length - 2 ? _i + 1 : this.summitList.length - 1;
      this.swiper.slideNext();
    },
    toSlide(index) {
      this.swiper.slideTo(index);
      this.currentSummit = index;
    },
    filterData(records) {
      // this.sList = records['401'];
      this.summitList = records['402'].sort((a, b) => a.sort - b.sort);
    },
    getData(language) {
      this.$http.getOnlyContent({
        itemType: '4',
        platform: 'pc',
        language
      }).then(res => {
        this.filterData(res.crmOweContentMaps || {});
        this.banner = res.imageMaps['40'][0];
      });
    },
    getDataByLang(lang) {
      if(lang === 'zh') {
        this.getData('china');
      } else {
        this.getData('english');
      }
    }
  },
  watch: {
    lang: {
      immediate: true,
      handler(v) {
        this.getDataByLang(v);
      }
    }
  }
}
</script>

<style lang="less">
.pc-home {
  .activity {
    .pane-title {
      //justify-content: center;
    }
    .tab-list {
      text-align: center;
      display: flex;
      justify-content: center;
      margin-bottom: 46px;
      .tab-item {
        width: 20%;
        text-align: center;
        height: 46px;
        line-height: 46px;
        background: #eee;
        cursor: pointer;
        //border: 1px solid ;
      }
      .active-item {
        background: #037698;
        color: #fff;
      }
      .tab-item-1 {
        border-right: 1px solid #7F7F7F;
        border-left: 1px solid #7F7F7F;
      }
    }
    .swiper-box {
      position: relative;
      margin-bottom: 200px;
      .swiper-slide {
        padding: 15px;
        .box {
          padding: 15px 15px 53px;
          box-shadow: 0 4px 8px 0 rgba(0,17,24,0.26);
        }
        img {
          width: 100%;
          display: block;
          margin-bottom: 30px;
        }
        .bottom-msg {
          padding: 0 35px;
        }
        .tit {
          font-size: 20px;
          font-weight: bold;
          color: #037698;
          margin-bottom: 20px;
        }
        .txt {
          font-size: 18px;
          font-weight: 400;
          color: #2E2E2E;
          line-height: 29px;
          text-indent: 2em;
          margin-bottom: 30px;
          text-align: justify;
        }
        .more-link {
          text-align: right;
        }
      }
      .btn {
        position: absolute;
        cursor: pointer;
        top: 0;
        height: 100%;
        padding-top: 40%;
        img {
          left: 0;
          width: 50px;
          height: 97px;
        }
      }
      .prev {
        left: -80px;
      }
      .next {
        right: -80px
      }
    }
  }
}
</style>
